import axios from "axios";
import { getCurrentLocale } from "@/locales";

let locale = getCurrentLocale();
console.log("locale", locale);

const API_BASE_URL = "https://api.haj.kz/api/v1";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    LANG: locale,
  },
});

// Переменная для отслеживания процесса обновления токена
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });

  failedQueue = [];
};

// Функция для обновления токена
const refreshToken = async () => {
  try {
    const refreshTokenValue = localStorage.getItem("refreshToken");
    if (!refreshTokenValue) {
      throw new Error("Refresh token не найден");
    }

    const response = await apiClient
      .post(`/jwt/token/refresh/`, {
        refresh: refreshTokenValue,
      })
      .catch((error) => {
        console.log("error", error);
        throw error;
      })
      .finally(() => {
        console.log("finally");
      });

    console.log("response", response);

    const { access, refresh } = response.data;

    // Сохраняем новые токены
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);

    return access;
  } catch (error) {
    console.log("error", error);
    // Если refresh token тоже истек, очищаем все токены
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    throw error;
  }
};

// Интерцептор для запросов
apiClient.interceptors.request.use(
  (config) => {
    // Здесь можно добавить токен авторизации если нужно
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для ответов
apiClient.interceptors.response.use(
  (response) => {
    return { ...response.data, responseStatus: response.status };
  },
  async (error) => {
    const originalRequest = error && error.config;
    console.log("originalRequest", error.response.data.code);

    if (error?.response?.data?.code === "token_not_valid") {
      console.log("token_not_valid");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.reload();
      return Promise.reject(error);
    }

    // Если ошибка 401 и это не повторный запрос
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      console.log("401", originalRequest._retry);
      if (isRefreshing) {
        console.log("isRefreshing");
        // Если уже идет обновление токена, добавляем запрос в очередь
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return apiClient(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      console.log("originalRequest._retry", originalRequest);
      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log("refreshToken");
        const newToken = await refreshToken();
        processQueue(null, newToken);

        // Повторяем оригинальный запрос с новым токеном
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        console.log("refreshError", refreshError);
        processQueue(refreshError, null);

        // Если refresh token тоже истек, перенаправляем на страницу логина
        // Здесь можно добавить редирект на страницу логина
        // window.location.href = '/login';

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
